'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';

const getProgressTestId = (text: string) =>
  `launch-progress-${text.toLowerCase().replaceAll(' ', '-')}`;

export const renderProgress = (text: string, isComplete?: boolean) => (
  <AgxSpacer
    direction="horizontal"
    fill
    gap="spacing-ml"
    padding={{ top: 'lg', bottom: 'lg' }}
  >
    <span className="launchProgressText">
      <AgxTypography id={getProgressTestId(text)} type="body_ui" size="small">
        {text}
      </AgxTypography>
    </span>
    <span
      className={`launchProgressValue ${isComplete ? 'complete' : 'pending'}`}
    >
      <AgxTypography
        id={`${getProgressTestId(text)}-status`}
        type="body_ui"
        size="small"
        color="inherit"
      >
        {isComplete ? 'complete' : 'pending'}
      </AgxTypography>
    </span>
  </AgxSpacer>
);
